import PropTypes from 'prop-types';
import React from 'react';

export const UnderlyingPriceExitWrapper = ({
  softOrder,
  Component,
  ...rest
}) => {

  const details = {
    tacticName: 'UNDERLYING_PRICE_EXIT',
    category: 'Exit',
    type: 'Underlying Price Exit',
    domain: 'Underlying',
  };
  // underlyingPriceExits is option-mode only - default to [] so a stock payload (which only ever
  // carries pendingTargets) never trips a .map() on undefined
  const { underlyingPriceExits = [], pendingTargets = [] } = softOrder;

  return <Component details={details} underlyingPriceExits={underlyingPriceExits} pendingTargets={pendingTargets} {...rest} />;
};

UnderlyingPriceExitWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    underlyingPriceExits: PropTypes.array,
    pendingTargets: PropTypes.array
  })
};
